import type { VehicleType } from "@/types";

// Catálogo de modelos de veículo — cada entrada é auto-contida (label,
// categoria de fallback e função de desenho opcional). Para adicionar um novo
// modelo no futuro: criar um arquivo em ./svgs/<nome>.ts exportando uma
// função `render(color: string): string` (ou um .glb fotorrealista, ver
// scripts/render-vehicle-icons/) e adicionar UMA linha abaixo. Nenhum outro
// arquivo (mapa, picker, service) precisa mudar.
//
// 2026-08-13: os 12 modelos SVG (sedan, suv, pickup, van, truck, semi, bus,
// moto, scooter, bike, excavator, tractor) foram removidos a pedido — ficaram
// visualmente ruins comparados ao Hatchback 3D. Só o Hatchback resta por
// enquanto; todo veículo (de qualquer categoria/tipo) usa esse ícone até
// existir um modelo 3D próprio pra cada tipo.
//
// 2026-09-28: volta a Moto, agora procedural (scripts/render-vehicle-icons/
// procedural/moto.ts, estilo R3) — veículos do tipo "moto" usam ela por
// padrão, e devices antigos com iconKey "moto" salvo passam a mostrá-la.
//
// 2026-10-02: BYD Dolphin (.glb fotorrealista), escolhido manualmente no
// seletor — não é padrão de nenhuma categoria.
//
// 2026-10-03: Caminhão baú (VW 9.150, .glb) — padrão da categoria "truck".
//
// 2026-10-08: Porsche 911 (.glb), escolha manual (veículo de demonstração).
//
// 2026-11-04: Patinete elétrico (.glb enviado pela aba Super Master >
// Modelos 3D), escolha manual.
export type VehicleModelKey = "hatchback" | "moto" | "byd" | "caminhao" | "porsche" | "patinete";

export interface VehicleModelDef {
  key: VehicleModelKey;
  label: string;
  category: VehicleType; // usado como fallback de agrupamento/filtro
  // Ausente pros modelos 100% fotorrealistas (fonte é .glb, ver
  // src/lib/vehicle-icons/photo-registry.ts) — nesse caso vehicleIconDataUri
  // nunca cai no SVG porque o registry de fotos cobre toda a paleta de cores.
  render?: (color: string) => string;
  // Multiplicador do tamanho do marcador no mapa (44px * mapScale). A moto é
  // estreita — com o mesmo tamanho do carro ela some no mapa.
  mapScale?: number;
}

export const VEHICLE_MODELS: VehicleModelDef[] = [
  { key: "hatchback", label: "Hatchback", category: "car" },
  { key: "moto", label: "Moto", category: "moto", mapScale: 1.2 },
  { key: "byd", label: "BYD Dolphin", category: "car" },
  { key: "caminhao", label: "Caminhão", category: "truck", mapScale: 1.25 },
  { key: "porsche", label: "Porsche 911", category: "car" },
  { key: "patinete", label: "Patinete elétrico", category: "moto", mapScale: 1.2 },
];

export const VEHICLE_MODEL_MAP: Record<VehicleModelKey, VehicleModelDef> = Object.fromEntries(
  VEHICLE_MODELS.map((m) => [m.key, m]),
) as Record<VehicleModelKey, VehicleModelDef>;

export function defaultModelForCategory(category?: VehicleType): VehicleModelKey {
  if (category === "moto") return "moto";
  if (category === "truck") return "caminhao";
  return "hatchback";
}
